module.exports = __webpack_public_path__ + "img/wallet.c4ca5f41.svg";